import React, { useEffect, useReducer, useState } from 'react';
import colors from '../../assets/styles/colors';
import Copyright from '../../components/Copyright';
import FormSteps from '../../components/FormSteps';
import Loader from '../../components/Loader';
import { H4, P } from '../../components/Typography/styles';
import {
 DocumentSigningContainer,
 DocumentSigningWrapper,
 DocumentSigningHeader,
 DocumentSigningHeaderTitle,
 DocumentSigningHeaderArea,
 DocumentSigningContent
} from './styles';
import { useHistory, useLocation } from 'react-router-dom';
import { getCreditById } from '../../services/credit';
import { getSolicitationById } from '../../services/solicitations';
import documentSigningReducer from '../../store/DocumentSigning';
import INITIAL_STATE_DOCUMENT_SIGNING from '../../store/DocumentSigning/state';
import { DocumentSigningContext } from '../../store';
import { default as DocumentSigningTypes } from '../../store/DocumentSigning/types';
import { documentSigningSteps } from '../../helpers/enum';
import DigitalDocumentsPage from './DigitalDocuments';
import DownloadDocumentsPage from './DownloadDocuments';
import UploadDocumentsPage from './UploadDocuments';

const DocumentSigningPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [documentSigning, setDocumentSigning] = useReducer(documentSigningReducer, INITIAL_STATE_DOCUMENT_SIGNING);
  const [activeStep, setActiveStep] = useState(documentSigningSteps.DIGITAL_DOCUMENTS);
  const [lastStep, setLastStep] = useState(documentSigningSteps.DEFAULT);
  const [isLoading, setIsLoading] = useState(true);

  async function initializeStateComponent() {
    try {
      const creditResponse = await getCreditById(location.idCredit);
      const solicitationResponse = await getSolicitationById(location.idCredit);

      setDocumentSigning({
        type: DocumentSigningTypes.SET_CREDIT,
        credit: creditResponse.data
      })

      setDocumentSigning({
        type: DocumentSigningTypes.SET_SOLICITATION,
        solicitation: solicitationResponse.data
      })
      setActiveStep(documentSigningSteps.UPLOAD_DOCUMENTS);
      /*if(location.step) {
        setActiveStep(location.step);
        setLastStep(documentSigningSteps.DIGITAL_DOCUMENTS);
      }*/
      setIsLoading(false)
    } catch (error) {
      
    }
  }

  useEffect(() => {
    if(!location.idCredit) {
      return history.push('/admin/dashboard');
    }

    initializeStateComponent();
  }, [])

  return (
    <DocumentSigningContainer id="document-signing-page">
      {isLoading ? <Loader /> : (
        <>
          <DocumentSigningWrapper>
          <DocumentSigningHeader>
            <DocumentSigningHeaderTitle>Clientes</DocumentSigningHeaderTitle>
            <DocumentSigningHeaderArea>
              <H4 color={colors.textPrimary}>Generación documentos y anexos</H4>
              <P bold color={colors.textPrimary}>
                {documentSigning.solicitation?.cliente.nombres} {documentSigning.solicitation?.cliente.tipoIdentificacion.toUpperCase()}. {documentSigning.solicitation?.cliente.identificacion}
              </P>
            </DocumentSigningHeaderArea>
          </DocumentSigningHeader>

          <DocumentSigningContent id="document-signing-steps">
            <FormSteps lastStep={lastStep} steps={[
              {number: documentSigningSteps.UPLOAD_DOCUMENTS, label: 'Sube documentos adicionales'}
              /*{number: documentSigningSteps.DIGITAL_DOCUMENTS, label: 'Firma digital documentos'},
              {number: documentSigningSteps.DOWNLOAD_DOCUMENTS, label: 'Descarga de documentos a firmar'}*/,
            ]} />

            <DocumentSigningContext.Provider value={{ documentSigning, setDocumentSigning }}>
              {activeStep === documentSigningSteps.DIGITAL_DOCUMENTS && (
                <DigitalDocumentsPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}

              {activeStep === documentSigningSteps.DOWNLOAD_DOCUMENTS && (
                <DownloadDocumentsPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}

              {activeStep === documentSigningSteps.UPLOAD_DOCUMENTS && (
                <UploadDocumentsPage setActiveStep={setActiveStep} setLastStep={setLastStep} />
              )}
            </DocumentSigningContext.Provider>
          </DocumentSigningContent>
        </DocumentSigningWrapper>
        <Copyright />
      </>
      )}
    </DocumentSigningContainer>
  )
}

export default DocumentSigningPage;
